const ActionTypes = {
  OPEN_SIDE_MENU: '[Application] Open Side Menu',
  CLOSE_SIDE_MENU: '[Application] Close Side Menu',
  TOGGLE_SIDE_MENU: '[Application] Toggle Side Menu',
}

export class OpenSideMenu {
  static type = ActionTypes.OPEN_SIDE_MENU;
}

export class CloseSideMenu {
  static type = ActionTypes.CLOSE_SIDE_MENU;
}

export class ToggleSideMenu {
  static type = ActionTypes.TOGGLE_SIDE_MENU;
}


